




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CantusMundiForum extends Vue {
  @Prop() private msg!: string;
}
